// extracted by mini-css-extract-plugin
module.exports = {"baseTabs":"MainTabs_baseTabs__3ufwO","headTab":"MainTabs_headTab__2gZY6","tabs":"MainTabs_tabs__2o9f5","tabItem":"MainTabs_tabItem__1pnSm"};